import React from "react";
import Select from "react-select";

// types
import { SelectInputProps } from "../../../types/components/dynamicForms/dynamicField";
import { FieldOption } from "../../../types/components/dynamicForms";
import { DROPDOWN_STYLES } from "../../../constants/theme";

/**
 * Presentational select. Wraps react-select but exposes a CODE-STRING value in
 * and out — the form stores "CAR", never the option object. This aligns stored
 * value === validated value (buildZodSchema refines the code) === submitted
 * value, which is what keeps the whole engine coherent. react-select's option
 * object is an internal detail mapped at this boundary only.
 *
 * No react-hook-form awareness. menuPortalTarget=body so the menu escapes the
 * card without needing overflow:hidden (see the .bwp-card clipping lesson).
 */
const SelectInput = ({
  id,
  value,
  onChange,
  onBlur,
  disabled,
  describedById,
  invalid,
  placeholder,
  options,
  formatOptionLabel,
}: SelectInputProps) => {
  const selected = options.find((o) => o.value === value) ?? null;

  return (
    <Select<FieldOption>
      inputId={id}
      className="bwp-field__control bwp-field__control--select"
      classNamePrefix="bwp-select"
      isDisabled={disabled}
      placeholder={placeholder ?? "Select..."}
      options={options}
      value={selected}
      getOptionLabel={(o) => o.label}
      getOptionValue={(o) => o.value}
      isOptionDisabled={(o) => Boolean(o.disabled)}
      onChange={(opt) => onChange(opt ? opt.value : "")}
      onBlur={onBlur}
      formatOptionLabel={formatOptionLabel}
      menuPortalTarget={typeof document !== "undefined" ? document.body : undefined}
      styles={{
        ...DROPDOWN_STYLES,
        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
      }}
      aria-invalid={invalid || undefined}
      aria-describedby={describedById}
    />
  );
};

export default SelectInput;